<template>
    <div class="card mb-2" @click="toApplyStatusDetail(item.id)">
        <div class="card-body let-space-1 p-2 pt-2 item-hover">
            <div>
                <span>{{converVal('sys_ap_flg', item.sys_ap_flg)}}</span>
                <span v-if="item.proj_open_flg == '0'">
                    <span v-if="isOverFinish(item.proj_finish_date)" class="text-danger">
                        <small>期限切れ</small>
                    </span>
                    <span v-else class="text-success">
                        <i class="fas fa-comment"></i>
                        <small> 募集中</small>
                    </span>
                </span>
                <span v-else-if="item.proj_open_flg == '1'" class="text-danger">
                    <i class="fas fa-comment-slash"></i>
                    <small> 募集終了</small>
                </span>
                <span v-else class="text-muted">
                    <i class="fas fa-comment-slash"></i>
                    <small> 削除済み</small>
                </span>
                <span class="text-success" :class="{'text-danger':isWarnFinishDate(item.proj_finish_date)}">
                    &nbsp;<i class="fas fa-hourglass-half"></i>
                    <small>{{editFinishDate(item.proj_finish_date, 2)}}</small>
                </span>
            </div>
            <div>
                <span class="border rounded px-1">
                    <small v-if="item.apply_mode = '0'">ap.{{item.id}} / te.{{item.te_id}} -> pj.{{item.pj_id}}</small>
                    <small v-else>ap.{{item.id}} / pj.{{item.pj_id}} -> te.{{item.te_id}}</small>
                </span>
                <span class="border rounded px-1">
                    <small v-if="item.apply_type = '0'">個人</small>
                    <small v-else-if="item.apply_type = '1'">法人</small>
                    <small v-else>SYS</small>
                </span>
                </span>
            </div>
            <div>
                <i v-if="$route.params.id == item.id" class="fas fa-star icon-size"></i>
                {{item.proj_nm}}
            </div>
            <div class="d-flex text-muted let-space-1 pt-0">
                <span class="flex-fill text-nowrap text-right">
                        <small>
                            <small>
                                <i class="fas fa-calendar"></i>
                                {{item.created_at | dformatm}}
                            </small>
                        </small>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import {editProjFinishDate
           ,isOverProjFinishDate
           ,isWarningProjFinishDate
           } from 'pages/commons/form/comFunc'
    import {converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            item: Object,
        },
        methods: {
            toApplyStatusDetail (id) {
                this.$store.dispatch('loadApplyStatusDetail',{
                    id: this.item.id
                })
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            editFinishDate (val, p) {
                return editProjFinishDate(val, p)
            },
            isWarnFinishDate (val) {
                return isWarningProjFinishDate(val)               
            },
            isOverFinish (val) {
                return isOverProjFinishDate(val)
            },
        }
    }
</script>

<style lang="stylus" scoped>
</style>
